import UserType from "../constants/UserType";
import { ProfileCompletenessDataItem } from "../interfaces/General";
import User from "../interfaces/User";
import { STRIPE_ACCOUNT_STATUS } from "../types/enums";

const userParameter: { label: string; fieldName: keyof User }[] = [
  { label: "Profile Image", fieldName: "profileImage" },
  // { label: "Email Address", fieldName: "email" },
  // { label: "Phone Number", fieldName: "phoneNumber" },
  { label: "Location", fieldName: "address" },
  { label: "Date of birth", fieldName: "dob" },
];

const chefParameter: { label: string; fieldName: keyof User }[] = [
  ...userParameter,
  { label: "Bio", fieldName: "bio" },
  { label: "Cuisine Types", fieldName: "cuisineTypes" },
  { label: "Culinary Training", fieldName: "culinaryTraining" },
  // { label: "Other Training", fieldName: "otherTraining" },
  { label: "Chef Services", fieldName: "chefServices" },
  { label: "Hourly Rate", fieldName: "hourlyRate" },
  { label: "Proof of Insurance", fieldName: "proofOfInsurance" },
  { label: "Food Safety Certification", fieldName: "serveSafe" },
  { label: "Tagline", fieldName: "tagline" },
];

const clientParameter: { label: string; fieldName: keyof User }[] = [
  ...userParameter,
  { label: "Culinary Preferences", fieldName: "foodPreferences" },
];

const getProfileCompletenessValue = (
  user: User
): {
  value: number;
  data: ProfileCompletenessDataItem[];
} => {
  //TODO Check images separatly
  const data: ProfileCompletenessDataItem[] = [];
  let value: number = 0;
  let parameter =
    user.userType === UserType.Chef ? chefParameter : clientParameter;

  parameter.forEach((each) => {
    if (user[each.fieldName] !== undefined) {
      value++;
      data.push({
        isCompleted: true,
        label: each.label,
        fieldName: each.fieldName,
      });
    } else {
      data.push({
        isCompleted: false,
        label: each.label,
        fieldName: each.fieldName,
      });
    }
  });

  if (user.userType === UserType.Chef) {
    // Check stripe status
    if (user.stripe_account_status === STRIPE_ACCOUNT_STATUS.SUCCESSFUL) {
      value++;
      data.push({
        isCompleted: true,
        label: "Stripe Account",
        fieldName: "stripe_account_status",
      });
    } else {
      data.push({
        isCompleted: false,
        label: "Stripe Account",
        fieldName: "stripe_account_status",
      });
    }

    // Check image is uploaded or not
    if (!user.imagesCount || user.imagesCount === 0) {
      data.push({
        isCompleted: false,
        label: "Images",
        fieldName: "imagesCount",
      });
    } else {
      value++;
      data.push({
        isCompleted: true,
        label: "Images",
        fieldName: "imagesCount",
      });
    }
  }

  // Check contract is signed
  // COMMENTED OUT: Contract signing requirement removed - replaced with terms checkbox in signup
  // if (user.contractSigned) {
  //   value++;
  //   data.push({
  //     isCompleted: true,
  //     label: "Contract Sign",
  //     fieldName: "contractSigned",
  //   });
  // } else {
  //   data.push({
  //     isCompleted: false,
  //     label: "Contract Sign",
  //     fieldName: "contractSigned",
  //   });
  // }

  value = Math.ceil((100 * value) / Object.keys(data).length);

  return { value, data };
};

export default getProfileCompletenessValue;
